<template>
  <LayoutDashboard title="Cadastro de Forma de Pagamento">
    <v-card outlined>
      <v-card-title>
        <v-flex xs12>
          <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
            <v-tab>
              <span>GERAL</span>
            </v-tab>

            <v-tab>
              <span>BANDEIRAS</span>
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs-items v-model="tabs" class="pa-8">
          <v-tab-item>
            <v-form ref="formGeral">
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFormaPagamento.nome"
                    label="Descrição *"
                    :rules="rules.nome"
                    class="ml-1 mr-1"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFormaPagamento.acrescimo"
                    label="Acréscimo %"
                    class="ml-1 mr-1"
                    v-mask="['#,##', '##,##', '###,##']"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFormaPagamento.ordem_exibicao"
                    label="Ordem de Exibição"
                    class="ml-1 mr-1"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFormaPagamento.ordem_exibicao"
                    label="Ordem de Exibiçao"
                    class="ml-1 mr-1"
                    type="number"
                    v-mask="['#,##', '##,##', '###,##']"
                  >
                  </v-text-field>
                </v-flex> -->
                
                <v-flex xs12 md12>
                  <v-select 
                  :items="getFormasPagamentoNfe" 
                  label="Informar na nf-e como:" 
                  v-model="getFormaPagamento.forma_pagamento_nfe" 
                  outlined 
                  class="ml-1 mr-1"
                  dense 
                  item-text="descricao" 
                  item-value="codigo">
                  </v-select>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="getFormaPagamento.prazo"
                    label="Gera contas a receber"
                    class="ml-1 mr-1"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="getFormaPagamento.transporta_valor"
                    label="Transporta Valor do Fechamento de Caixa"
                    class="ml-1 mr-1"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="getFormaPagamento.abate_credito_cliente"
                    label="Abate crédito do cliente"
                    class="ml-1 mr-1"
                  ></v-checkbox>
                </v-flex>
                <!-- <v-flex xs12 md4 v-if="getFormaPagamento.prazo">
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    v-model="getFormaPagamento.numero_parcelas"
                    label="Números de parcelas *"
                    class="ml-1 mr-1"
                    :rules="rules.numero_parcelas"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 v-if="getFormaPagamento.prazo">
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    v-model="getFormaPagamento.intervalo"
                    label="Dias de intervalo entre parcelas *"
                    class="ml-1 mr-1"
                    :rules="rules.prazo"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4 v-if="getFormaPagamento.prazo">
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    v-model="getFormaPagamento.primeira_parcela"
                    label="Pimeira parcela *"
                    class="ml-1 mr-1"
                    :rules="rules.primeira_parcela"
                  ></v-text-field> -->
              </v-layout>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-autocomplete
                    :items="getBandeirasCartao"
                    item-text="nome"
                    v-model="bandeiraCartao"
                    item-value="nome"
                    outlined
                    dense
                    return-object
                    label="Bandeira"
                    class="ml-1 mr-1"
                    append-icon="control_point"
                    @click:append="cadastrarBandeiraCartao"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Número máximo de parcelas"
                    v-model="numeroMaximoParcelas"
                    outlined
                    dense
                    class="ml-1 mr-1"
                    append-outer-icon="control_point"
                    @click:append-outer="addBandeira"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <v-simple-table dense v-if="bandeirasCartao.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Bandeira</th>
                    <th>Número máximo de parcelas</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="b in bandeirasCartao" :key="b.id">
                    <td>{{ b.nome }}</td>
                    <td>{{ b.numero_maximo_parcelas }}</td>
                    <th>
                      <v-btn color="error" outlined dense @click="removerBandeira" x-small>
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" @click="$router.push({ name: 'formasPagamentos' })" outlined> Voltar</v-btn>

        <v-btn
          v-if="$route.params.id && $helper.verificaPermissao('cadastrar-forma-pagamento')"
          color="primary"
          @click="cadastrarFormaPagamento"
          outlined
          >Novo
        </v-btn>

        <v-btn
          v-if="$route.params.id && $helper.verificaPermissao('excluir-forma-pagamento')"
          color="error"
          @click="setModalExcluirFormaPagamento(true)"
          outlined
        >
          Excluir</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="salvar"
          outlined
          v-if="
            $helper.verificaPermissao('cadastrar-forma-pagamento') ||
              $helper.verificaPermissao('atualizar-forma-pagamento')
          "
        >
          Salvar</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="getModalExcluirFormaPagamento" max-width="500px">
      <v-card>
        <v-card-title>Excluir</v-card-title>
        <v-card-text>
          <h3 align="center">
            Tem certeza que deseja excluir esta forma de pagamento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="setModalExcluirFormaPagamento(false)" outlined>NÃO</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="excluirFormaPagamento(getFormaPagamento)" outlined>SIM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalCadastroBandeiraCartao />
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastroBandeiraCartao from "@/pages/formaPagamento/bandeiraCartao/ModalCadastro";

export default {
  components: {
    ModalCadastroBandeiraCartao,
  },
  data() {
    return {
      tabs: 0,
      modalExcluir: false,
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
        nome: [(v) => !!v || "Campo obrigatório."],
        numero_parcelas: [(v) => !!v || "Campo obrigatório."],
        prazo: [(v) => !!v || "Campo obrigatório."],
        primeira_parcela: [(v) => !!v || "Campo obrigatório."],
      },
      bandeiraCartao: {},
      bandeirasCartao: [],
      numeroMaximoParcelas: 1,
    };
  },
  computed: {
    ...mapGetters(["getFormaPagamento", "getModalExcluirFormaPagamento", "getBandeirasCartao", "getFormasPagamentoNfe"]),
  },
  methods: {
    ...mapActions([
      "salvarFormaPagamento",
      "atualizarFormaPagamento",
      "editarFormaPagamento",
      "cadastrarFormaPagamento",
      "setModalExcluirFormaPagamento",
      "excluirFormaPagamento",
      "listarBandeiraCartao",
      "cadastrarBandeiraCartao",
    ]),
    salvar() {
      if (this.$refs.formGeral.validate()) {
        if (this.bandeirasCartao.length > 0) {
          this.getFormaPagamento.bandeiras_cartao = this.bandeirasCartao;
        } else {
          this.getFormaPagamento.bandeiras_cartao = null;
        }

        if(!this.getFormaPagamento.forma_pagamento_nfe){
          this.getFormaPagamento.forma_pagamento_nfe = 99;
        }

        // if(!this.getFormaPagamento.bandeira_pagamento_nfe){
        //   this.getFormaPagamento.bandeira_pagamento_nfe = 99;
        // }

        if (this.getFormaPagamento.id) {
          this.atualizarFormaPagamento(this.getFormaPagamento);
        } else {
          this.salvarFormaPagamento(this.getFormaPagamento);
        }
      }
    },
    addBandeira() {
      this.bandeirasCartao.push({
        id: this.bandeiraCartao.id,
        nome: this.bandeiraCartao.nome,
        codigo: this.bandeiraCartao.codigo,
        numero_maximo_parcelas: this.numeroMaximoParcelas,
      });
    },
    removerBandeira(id) {
      let index = this.bandeirasCartao.map((i) => i.id).indexOf(id);
      this.bandeirasCartao.splice(index, 1);
    },
  },
  created() {
    this.listarBandeiraCartao();
    if (this.$route.params.id) {
      this.editarFormaPagamento(this.$route.params.id).then((res) => {
        if (this.getFormaPagamento.bandeiras_cartao) {
          this.bandeirasCartao = this.getFormaPagamento.bandeiras_cartao;
        }
      });
    }
  },
};
</script>
